module.exports = __webpack_public_path__ + "967706c4b968e2d8304d0bbf9ccf2dfd.MP3";